import template from './period-picker.html'

export let periodPicker = {
  bindings: {
    onChange: '&',
    toggleRange: '&',
    typePeriod: '<',
    formReference: '<',
    rangeType: '<',
    startDate: '<',
    endDate: '<',
    periodsArray: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['GlobalConfig',
    function periodPickerCtrl (GlobalConfig) {
      angular.extend(this, {
        selectedTypePeriod: {},
        isTouchedPeriods: true,
        // minStartDate: new Date(),
        // minEndDate: new Date(),
        minStartDate:moment(this.startDate)._d,
        //minStartDateVALUE:moment('2018-02-01T00:00:00.000')._d,
        minEndDate: moment(this.endDate)._d,
        //minEndDate: new Date(),
        showType: 'PERIODS'
      })
      const periodsId = GlobalConfig.periods.rangeType

      this.$onInit = () => {
        this.showType = Number(this.rangeType) === periodsId ? 'PERIODS' : 'DATES'
      }

      this.$onChanges = () => {
        this.showType = Number(this.rangeType) === 1 ? 'PERIODS' : 'DATES'
        if (this.periodsArray.length > 0) this.periodsArray.forEach(id => { this.selectedTypePeriod[id] = true })
      }

      const validateCheklistPeriods = () => Number(this.rangeType) === periodsId ? this.periodsArray.length < 1 : false

      const setVariables = (bool) => {
        this.showType = bool ? 'PERIODS' : 'DATES'
        if (bool) {
          this.startDate = null
          this.endDate = null
        } else {
          this.periodsArray = []
          this.selectedTypePeriod = null
          this.startDate = null
          this.endDate = null
        }
      }

      const funSelectedPeriod = (period, checked) => {
        if (checked) {
          if (!this.periodsArray.includes(period.periodId)) {
            this.periodsArray.push(period.periodId)
          }
        } else {
          let index = this.periodsArray.indexOf(period.periodId)
          if (index !== -1) {
            this.periodsArray.splice(index, 1)
          }
        }
        this.isTouchedPeriods = true
        return {value: {periods: this.periodsArray, dates: [this.startDate, this.endDate]}}
      }

      const startDateChange = () => {
        let m = moment(this.startDate)
        this.minEndDates = m.isValid() ? m.toDate() : null
        return {value: {periods: this.periodsArray, dates: [this.startDate, this.endDate]}}
      }

      angular.extend(this, {
        setVariables: setVariables,
        funSelectedPeriod: funSelectedPeriod,
        startDateChange: startDateChange,
        validateCheklistPeriods: validateCheklistPeriods
      })
    }
  ]
}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/period-picker.js